<template>
  <div
    class="
      full-height
      full-width
      is-flex
      is-flex-direction-column
      send-verify-email
    "
  >
    <header class="send-verify-email__header">
      <img
        src="@/assets/images/logo.svg"
        alt="Logo"
        class="send-verify-email__header--logo"
      />
    </header>
    <div class="
      full-width
      is-align-items-center
      is-flex
      is-flex-direction-column
      is-justify-content-center
    ">
      <div class="
        is-align-items-center
        is-flex
        is-flex-direction-column
        is-justify-content-center
        send-verify-email__content
      ">
        <h1 class="has-text-black has-text-weight-light is-size-3 mb-4">
          {{ title }}連結已逾期
        </h1>
        <p class="mb-large send-verify-email__content--description">
          請輸入註冊的電子郵件地址，以重新發送驗證信
        </p>
        <div class="full-width mb-7">
          <b-field
            :message="v$.email.$errors[0] && v$.email.$errors[0].$message"
            :type="{ 'is-danger': v$.email.$errors[0] && v$.email.$errors.length }"
            custom-class="has-text-black has-text-left"
            horizontal
            label="電子郵件"
          >
            <b-input
              :use-html5-validation="false"
              v-model="v$.email.$model"
              type="email"
            />
          </b-field>
        </div>
        <b-button
          :disabled="loading || (v$.email.$invalid && v$.email.$dirty)"
          :loading="loading"
          class="mb-2 mt-4"
          expanded
          outlined
          type="is-primary"
          @click="resend"
        >
          {{ btnText }}
        </b-button>
        <p class="font-small has-text-black">
          找不到驗證信？請檢查您的垃圾郵件資料夾
        </p>
      </div>
    </div>
    <img
      alt="Send Verify Email Image"
      class="send-verify-email__image"
      src="@/assets/images/send-verify-email.svg"
      width="545px"
    />
  </div>
</template>

<script>
import SendVerifyEmail from './SendVerifyEmail';

export default SendVerifyEmail;
</script>

<style lang="scss" scoped>
@import 'SendVerifyEmail';
</style>
